import type { AxiosInstance } from 'axios';
import type { LocalizationLanguage } from '@gov-nx/core/app';
import type { ServiceCode } from '@gov-nx/module/service';
import type { CmsServiceResponse } from './types';

export interface CmsServiceQueryParams {
	code: ServiceCode;
	locale: LocalizationLanguage;
	cmsKeyCache: string;
}

export const cmsServiceQuery = async (
	axiosCmsInstance: AxiosInstance,
	{ code, locale, cmsKeyCache }: CmsServiceQueryParams
) => {
	const response = await axiosCmsInstance.get<CmsServiceResponse>(
		`/services/${code}-${locale}.json?v=${cmsKeyCache}`
	);
	return response.data.data;
};
